import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import {
  FlexCol,
  FlexRow,
  FlexRowCenterVertical,
} from '../../Defaults/Flexbox/Flexbox';
import { SvgIcon, IconType } from '../General/SvgIcon';
import { __ } from 'react-i18n';
import { TextP } from '../General/Text';

interface Props {
  price: number | string;
  oldPrice?: number | string;
  currency: string;
  toggleFavourite: any;
  favouriteProducts: any;
  productId: number;
  unit?: string;
}

function PriceInfo({
  price,
  oldPrice,
  currency,
  toggleFavourite,
  favouriteProducts,
  productId,
  unit,
}: Props) {
  const [isInFavourites, setIsInFavourites] = React.useState(
    favouriteProducts && favouriteProducts.includes(productId),
  );

  const toggleFavouriteProductDetail = () => {
    setIsInFavourites(val => !val);
  };

  const firstUpdate = React.useRef(true);
  React.useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    toggleFavourite(productId, isInFavourites);
  }, [isInFavourites]);

  return (
    <PricesWrapper>
      <Wrapper>
        <PriceFavouriteWrapper>
          <PriceWrapper>
            <Price>{`${price} ${currency}`}</Price>
            <PriceUnit>/{unit}</PriceUnit>
          </PriceWrapper>
          <IconWrapper>
            <SvgIcon
              icon={IconType.favourite}
              fill={isInFavourites ? '#D2A4B0' : 'rgba(7, 21, 28, 0.16)'}
              alt={
                isInFavourites ? `Váš obľúbený produkt` : `Pridať do obľúbených`
              }
              cursor={'pointer'}
              viewBox="0 0 24 24"
              marginRight={12}
              width={24}
              height={24}
              onClick={toggleFavouriteProductDetail}
            />
            <FavoriteText
              onClick={toggleFavouriteProductDetail}
              isFavouriteProduct={isInFavourites}
            >
              {isInFavourites ? `Váš obľúbený produkt` : `Pridať do obľúbených`}
            </FavoriteText>
          </IconWrapper>
        </PriceFavouriteWrapper>
        {oldPrice && oldPrice > price ? (
          <SecondaryText>
            {__('Predtým')}
            <OldPriceText>{`${oldPrice} ${currency}`}</OldPriceText>
          </SecondaryText>
        ) : null}
      </Wrapper>
    </PricesWrapper>
  );
}

const PricesWrapper = styled(FlexRowCenterVertical)`
  width: 100%;
`;

const PriceWrapper = styled(FlexRowCenterVertical)``;

const Wrapper = styled(FlexCol)`
  width: 100%;
  justify-content: space-between;
`;

const PriceFavouriteWrapper = styled(FlexRowCenterVertical)`
  width: 100%;
  justify-content: space-between;
`;

const IconWrapper = styled.div`
  text-align: center;
  position: relative;
  opacity: 0.56;
`;

const FavoriteText = styled.p<{ isFavouriteProduct: boolean }>`
  display: inline-block;
  text-decoration: none;
  color: ${({ theme, isFavouriteProduct }) =>
    isFavouriteProduct ? theme.colors.primary : theme.colors.textPrimary};
  font-size: ${rem(14)};
  line-height: ${rem(21)};
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 500;
  opacity: ${({ isFavouriteProduct }) => (isFavouriteProduct ? 1 : 0.56)};
  cursor: pointer;

  ${({ theme }) => theme.mediab.s450`
    display: none;
  `}
`;

const Price = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 500;
  font-size: ${rem(24)} !important;
  line-height: ${rem(28)};
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-bottom: ${rem(8)};
  white-space: nowrap;
`;

const PriceUnit = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-weight: 500;
  font-size: ${rem(18)} !important;
  color: ${({ theme }) => theme.colors.textPrimary};
  margin: 0 0 ${rem(8)} ${rem(8)};
  white-space: nowrap;
`;

const SecondaryText = styled(FlexRowCenterVertical)`
  display: inline-flex;
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(14)};
  line-height: ${rem(17)};
  color: ${({ theme }) => theme.colors.danger};
`;

const OldPriceText = styled(TextP)`
  color: ${({ theme }) => theme.colors.danger};
  text-decoration: line-through;
  margin-left: ${rem(8)};
`;

export { PriceInfo };
